import { generateJsxKey } from '@utils/ast';
import { PostloadedImage } from '@utils/react';
import { image } from './printer.image.style.js';
import { jsx } from 'react/jsx-runtime';

function printImage(data, context) {
  const alignment = data.attributes?.["class"]?.includes("fr-fil") ? "left" : data.attributes?.["class"]?.includes("fr-fir") ? "right" : "middle";
  const inline = !!data.attributes?.["class"]?.includes("dii");
  return /*#__PURE__*/jsx("div", {
    className: image,
    "data-alignment": alignment,
    "data-inline": inline,
    children: /*#__PURE__*/jsx(PostloadedImage, {
      alt: "",
      ...data.props
    })
  }, generateJsxKey(context));
}

export { printImage };
//# sourceMappingURL=printer.image.js.map
